import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, AutoCompleteSelectUI, FormErrorUI, FormLabelUI, DatePickerUI } from '../Interface';

const FormFields = ({ selectedValues, autoCompleteOptions }) => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-2 mx-4 mb-5">
      <div className="col-span-4">
        <Field
          type="text"
          name="simpleTaskName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Feladat rövid neve" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.simpleTaskName} />}
          InputLabelProps={{ shrink: values.simpleTaskName !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2 xl:col-span-1">
        <Field
          type="date"
          name="endDate"
          component={DatePickerUI}
          value={values.endDate}
          fullWidth
          label={<FormLabelUI text="Befejező dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.endDate} />}
          onChange={(date) => {
            setFieldValue('endDate', date).then(() => {
              validateField('endDate');
            });
          }}
          InputLabelProps={{ shrink: values.endDate !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2 xl:col-span-1">
        <Field
          type="autocomplete"
          name="priorId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Prioritás" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.priorId} />}
          onChange={(_e, newVal) => {
            setFieldValue('priorId', newVal?.value ?? null).then(() => {
              validateField('priorId');
            });
          }}
          InputLabelProps={{ shrink: values.priorId !== '' }}
          selectedValue={values.priorId}
          selectedLabelValue={selectedValues?.priority?.itemName}
          dataset={autoCompleteOptions.priority}
        />
      </div>
      <div className="col-span-4 md:col-span-2 xl:col-span-1">
        <Field
          type="autocomplete"
          name="resposiblePersonId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Felelős" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.resposiblePersonId} />}
          onChange={(_e, newVal) => {
            setFieldValue('resposiblePersonId', newVal?.value ?? null).then(() => {
              validateField('resposiblePersonId');
            });
          }}
          InputLabelProps={{ shrink: values.resposiblePersonId !== '' }}
          selectedValue={values.resposiblePersonId}
          selectedLabelValue={selectedValues?.user?.nickName}
          dataset={autoCompleteOptions.user}
        />
      </div>
    </div>
  );
};

export default FormFields;
